const globals = {
  numberDateLocale: "de-CH",
  numberFormats: {
    "de-CH": {
      currency: {
        style: "currency",
        currency: "CHF"
      },
      currencyNoSymbol: {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      decimal: {
        style: "decimal",
        maximumFractionDigits: 20
      },
      round: {
        style: "decimal",
        maximumFractionDigits: 2
      },
      valueChart: {
        style: "decimal",
        maximumFractionDigits: 3
      },
      meterValue: {
        style: "decimal",
        maximumFractionDigits: 9
      },
      currencyValue: {
        style: "currency",
        currency: "CHF"
      },
      proportionalValue: {
        style: "decimal",
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      }
    },
    "en-US": {
      currency: {
        style: "currency",
        currency: "CHF"
      },
      currencyNoSymbol: {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      decimal: {
        style: "decimal",
        maximumFractionDigits: 20
      },
      round: {
        style: "decimal",
        maximumFractionDigits: 2
      },
      valueChart: {
        style: "decimal",
        maximumFractionDigits: 3
      },
      meterValue: {
        style: "decimal",
        maximumFractionDigits: 9
      },
      currencyValue: {
        style: "currency",
        currency: "CHF"
      },
      proportionalValue: {
        style: "decimal",
        maximumFractionDigits: 3
      }
    }
  },
  DateFormats: {
    date: {
      full: "dddd, DD. MMMM YYYY",
      long: "DD. MMMM YYYY",
      medium: "DD.MM.YYYY",
      short: "DD.MM.YY"
    },
    time: {
      full: "HH:mm:ss",
      long: "HH:mm:ss",
      medium: "HH:mm:ss",
      short: "HH:mm"
    }
  }
};
export default globals;
